// extracted by mini-css-extract-plugin
export default {"certificate-permissions-table":"CertificatePermissionsTable_certificate-permissions-table__LuFMM"};